module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.section.page_content.length > 0) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v(_vm._s(_vm.section.heading))]), _vm._v(" "), (_vm.section.body) ? _c('p', {
    staticClass: "static-info--sub-teaser",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _vm._l((_vm.section.page_content), function(procurement, index) {
    return _c('sk-layout', {
      key: index,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h3', {
      staticClass: "static-info--heading"
    }, [_vm._v(_vm._s(procurement.title))])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_number))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender publication date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_publication_date))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender description")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.tender_description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Sk Procurement representive")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_name))]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.representative_email))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Date of modification of tender invitation")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.modification_date)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Tender collection time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.tender_collection_time))])]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Physical Address for tender response")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(procurement.physical_address)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "static-info--content"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("Special conditions (if any)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(procurement.special_conditions))])])])], 1)
  })], 2) : _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', {
    staticClass: "panel panel--black"
  }, [_vm._v("\n            There are no open tender invitations at the moment. Please check back as Ster-Kinekor will publish open\n            tenders as they become available.\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6069a270","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/procurement/procurement.vue
// module id = 655
// module chunks = 0